import { useEffect, useState } from 'react'

import Parser from 'html-react-parser'

import { Footer } from '../../components/Footer'
import { LoadingScreen } from '../../components/LoadingScreen'
import { sdk } from '../../services/sdk'

import styles from './styles.module.scss'

export const Cookies = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState('')

  const getCookies = async () => {
    try {
      setLoading(true)
      const response = await sdk.settings.getCookiePolicy()
      console.log('cookies', response)
      if (response) {
        setData(response.text)
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCookies()
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.scroll}>{Parser(data)}</div>
        </div>
      </div>
      <div className={styles.footer}>
        <Footer />
      </div>
      {loading && <LoadingScreen backgroundColor="transparent" />}
    </div>
  )
}
